import { PlayerRegistrationErrorCodes } from "./player_registration_error_codes";

export class PlayerRegistrationErrorParser {


    public static parse(response): string {

        if (!this._canParseError(response)) {
            // if (response.error != null) {
            //     return "MODULES.COMMON.MESSAGES.GENERIC_ERROR_UNKNOWN_ERROR";
            // }
            return "MODULES.LOGIN.REGN_PARSER_FAILURE";
        }

        try {
            const errorData = response.error;

            if (errorData.hasOwnProperty('errors') && errorData.errors != null) {
                // Key 'errors' exist
                if (this._isDuplicateAccountNumberError(errorData.errors![0])) {
                    return 'MODULES.EXISTINGPLAYERLINKING.EXT_DUPLICATE_ACCOUNT_NUMBER_MSG';
                }
                if (this._isRegistrationFieldError(errorData.errors![0])) {
                    return 'MODULES.LOGIN.REGN_ID_FIELD_ERROR_MSG';
                }
                if (this._isInvalidAccountNumberError(errorData.errors![0])) {
                    return 'MODULES.EXISTINGPLAYERLINKING.EXT_REGN_INVALID_ACCOUNT_NUMBER_ERROR_MSG';
                }

                if (this._isDuplicatePlayerError(errorData.errors)) {
                    return 'MODULES.LOGIN.REGN_PARSER_DUPLICATE_PLAYER_ERROR_MESSAGE';
                }

                const error = errorData.errors[0];

                if (error?.message) {
                    return error.message;
                }
            }
            return 'MODULES.LOGIN.REGN_PARSER_FAILURE';
        }
        catch (ex) {
            return 'MODULES.LOGIN.REGN_PARSER_FAILURE';
        }
    }

    private static _canParseError(response: any): boolean {
        return response &&
            response.error;
    }

    private static _isDuplicatePlayerError(errors: any[]): boolean {
        return errors?.some((error: any) =>
            error.code?.toLowerCase() === PlayerRegistrationErrorCodes.duplicatePlayerErrorCode.toLowerCase()
        ) ?? false;
    }

    static _isDuplicateAccountNumberError(error: any): boolean {
        return error.code != null &&
            error.code!.toLowerCase() ==
            PlayerRegistrationErrorCodes.DUPLICATE_ACCOUNT_NUMBER.toLowerCase();
    }

    static _isRegistrationFieldError(error: any): boolean {
        return error.code != null &&
            error.code?.toLowerCase() ==
            PlayerRegistrationErrorCodes.fieldErrorCode.toLowerCase();
    }

    static _isInvalidAccountNumberError(error: any): boolean {
        return error.code != null &&
            error.code?.toLowerCase() ==
            PlayerRegistrationErrorCodes.invalidAccountNumberErrorCode
                .toLowerCase();
    }
}